/** @jsxImportSource @emotion/react */

import React from 'react';
import { useTypedSelector } from '@hook/common/useStore';
import ToastTemplate from '@component/iyagigo/toast/toast-template';
import SignupWallToast from '@component/iyagigo/toast/wall-toast/signup-wall-toast';
import SubscriptionWallToast from '@component/iyagigo/toast/wall-toast/subscription-wall-toast';
import { isSignupWallToastDataType, isSubscriptionWallToastDataType } from '@datatype/iyagigo/type';

const WallToast = () => {
  const wallToastData = useTypedSelector((state) => state.rootReducer?.modalReducer?.wallToastData) || null;

  return (
    <ToastTemplate>
      {isSignupWallToastDataType(wallToastData) && <SignupWallToast data={wallToastData.data} />}
      {isSubscriptionWallToastDataType(wallToastData) && <SubscriptionWallToast data={wallToastData.data} />}
    </ToastTemplate>
  );
};

export default WallToast;
